import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { EndpointService } from '@app/endpoint/endpoint.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@app/user/user.service';
import { SharedUtilService } from '@app/_shared/shared-util.service';
import { constants } from '@assets/data/constants';

@Component({
  selector: 'app-autoselect-locator-modal',
  templateUrl: './autoselect-locator-modal.component.html',
  styleUrls: ['./autoselect-locator-modal.component.less']
})
export class AutoselectLocatorModalComponent implements OnInit {

  @Input() uiMeta: any;
  @Input() fieldName: any;
  @Input() webInstruction: any;
  @Input() webLocatorsList: any = [];
  @Input() userProjects: any;
  @Input() editAutoSelectedLoc: any;
  @Input() endPointDetails: any;
  @Input() baseLocator: boolean;
  @Input() edited: boolean;
  @Output() modalClosed: EventEmitter<any> = new EventEmitter();
  @Output() selectedLocator: EventEmitter<any> = new EventEmitter();

  // Pagination Details
  page = 1;
  pageSize = 10;
  previousPage: any;
  constants = constants;
  createForm: FormGroup;
  isNewPageLabel = false;
  pageLabelList: any = [];
  newPageLabelName: string;
  webEndPointList: any = [];
  shadowDomLocatorList = []

  constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder, private endPointService: EndpointService,
    private toastr: ToastrService, private userService: UserService, private sharedUtilService: SharedUtilService) { }

  ngOnInit() {
    this.setCreateForm();
    this.getWebEndPoints();
    this.getPageLabelListByProject();
    // this.getPageLabelList();
    this.getAllShadowDomLocators()
  }

  conditionalValidator(predicate, validator): Validators {
    return (formControl => {
      if (!formControl.parent) {
        return;
      }
      if (!predicate()) {
        return validator(formControl);
      }
      return;
    });
  }

  pageLabelRequiredValidator(pageLabelControl: AbstractControl): Validators {
    this.isNewPageLabel = !this.isNewPageLabel;
    if (!pageLabelControl.parent) {
      return;
    }
    if (!this.isNewPageLabel) {
      pageLabelControl.setValidators(Validators.required);
    } else {
      pageLabelControl.clearValidators();
      pageLabelControl.updateValueAndValidity();
    }
  }

  setCreateForm(): void {
    this.createForm = this.formBuilder.group({
      id: [''],
      name: [null, Validators.required],
      useJquery: [''],
      baseLocator: [''],
      shadowDom : [false],
      shadowRoot : [false],
      parentLocator : [],
      locatorType: [null, this.conditionalValidator(() => this.createForm.get('useJquery').value, Validators.required)],
      componentType: [null, Validators.required],
      locatorString: ['', Validators.required],
      pageLabel: [null, Validators.required]
    });
  }

  getWebEndPoints() {
    const projectIds = [this.endPointDetails.project.id];
    this.endPointService.getWebEndpointsByProjectsAndEndpointType(constants.typeWeb, projectIds).subscribe(data => {
      if (data.code === 200) {
        this.webEndPointList = data.response;
      } else if (data.code === 204) {
        this.webEndPointList = [];
      }
    });
  }

  getPageLabelList() {
    this.userService.getAllPageLabels().subscribe(data => {
      if (data.code === 200) {
        this.pageLabelList = data.response;
        if (!this.createForm.value.id) {
          this.createNewLocator();
        }
      } else {
        this.pageLabelList = [];
        this.createNewLocator();
      }
    });
  }

  getPageLabelListByProject() {
    this.userService.getPageLabelListByProject(this.endPointDetails.project.id).pipe().subscribe(data => {
      if (data.code === 200) {
        this.pageLabelList = data.response;
        if(this.edited) {
          this.editLocator();
        } else {
          this.createNewLocator();
        }
      } else {
        this.pageLabelList = [];
        this.createNewLocator();
      }
    });
  }

  getShadowDomLocators(event: any) {
    if(event.target.checked) {
      let params = {
        shadowDom : true,
        projectIds:	this.endPointDetails.project.id,
        size:1000
      };

      this.endPointService.getWebLocatorsList(params).subscribe(data => {
        if (data.code === 200) {
          this.shadowDomLocatorList = data.response.webLocators;
        }
      });
    }
  }
  getAllShadowDomLocators() {
    let params = {
      shadowDom: true,
      projectIds: this.endPointDetails.project.id,
      size: 1000
    };

    this.endPointService.getWebLocatorsList(params).subscribe(data => {
      if (data.code === 200) {
        this.shadowDomLocatorList = data.response.webLocators;
      }
    });

  }

  editLocator() {
    this.isNewPageLabel = false;
    this.newPageLabelName = '';
    this.createForm.patchValue({
      id: this.editAutoSelectedLoc?.id ? this.editAutoSelectedLoc?.id : this.editAutoSelectedLoc?.sqlId,
      name: this.editAutoSelectedLoc?.name,
      useJquery: this.editAutoSelectedLoc?.useJquery,
      baseLocator: this.editAutoSelectedLoc?.baseLocator,
      locatorType: this.editAutoSelectedLoc?.locatorType,
      componentType: this.editAutoSelectedLoc?.componentType,
      locatorString: this.editAutoSelectedLoc?.locatorString,
      pageLabel: this.editAutoSelectedLoc?.pageLabel.sqlId === undefined ? this.editAutoSelectedLoc?.pageLabel : this.pageLabelList.find((element) => element.name === this.editAutoSelectedLoc?.pageLabel?.name),
      shadowDom : this.editAutoSelectedLoc?.shadowDom,
      shadowRoot : this.editAutoSelectedLoc?.shadowRoot,
      parentLocator : this.editAutoSelectedLoc?.parentLocator !== null ? this.editAutoSelectedLoc?.parentLocator : null
      // pageLabel: this.editAutoSelectedLoc?.pageLabel.name ? this.editAutoSelectedLoc?.pageLabel : constants.pageUnlabelled,

    });
    console.log(this.createForm.value);
  }

  saveLocator() {
    let webLocator = Object.assign({}, this.createForm.value);
    webLocator.project = this.endPointDetails.project;
    if (webLocator.useJquery === undefined) {
      webLocator.useJquery = '';
    }
    if (webLocator.id === undefined) {
      webLocator.id = '';
    }
    if (webLocator.baseLocator === undefined) {
      webLocator.baseLocator = '';
    }
    if (webLocator.shadowDom === undefined) {
      webLocator.shadowDom = false;
    }
    if (webLocator.shadowRoot === undefined) {
      webLocator.shadowRoot = false;
    }
    if (webLocator.parentLocator === undefined) {
      webLocator.parentLocator = null;
    }

    if (this.isNewPageLabel) {
      webLocator.pageLabel = {
        id: null,
        name: this.newPageLabelName
      };
    }

    if (webLocator.id) {
      this.userService.updateWebLocator(webLocator).subscribe(data => {
        if (data.code === 200) {
          this.toastr.success(data.message);
          if (this.isNewPageLabel) {
            this.userService.getAllPageLabels().subscribe(pageLabels => {
              if (data.code === 200) {
                const selectedPageLabel = pageLabels.response.find(pageLabel => pageLabel.name === webLocator.pageLabel.name);
                webLocator.pageLabel = selectedPageLabel || webLocator.pageLabel;
                this.userService.getWebLocatorById(data.response.id).subscribe(data => {
                  if (data.code === 200) {
                    webLocator = {
                      ...webLocator, "project": null, "createdBy": null, "active": false,
                      "createdOn": null, "updatedBy": null, "updatedOn": null, "id": data.response.id,"parentLocator":data.response.parentLocator,
                    };
                    if (webLocator.baseLocator === '') {
                      webLocator.baseLocator = false;
                    }
                    if (webLocator.useJquery === '') {
                      webLocator.useJquery = false;
                    }
                    if (webLocator.shadowDom === '') {
                      webLocator.shadowDom = false;
                    }
                    if (webLocator.shadowRoot === '') {
                      webLocator.shadowRoot = false;
                    }
                  //  this.selectLocatorToField(data.response)
                  this.selectLocatorToField(webLocator);
                    this.close();
                    this.createForm.reset();
                  } else {
                    this.toastr.error(data.message);
                  }
                });

              } else {
                this.pageLabelList = [];
              }
            });
          }else{
            this.userService.getWebLocatorById(data.response.id).subscribe(data => {
              if (data.code === 200) {
                webLocator = {
                  ...webLocator, "project": null, "createdBy": null, "active": false,
                  "createdOn": null, "updatedBy": null, "updatedOn": null, "id": data.response.id,"parentLocator":data.response.parentLocator,
                };
                if (webLocator.baseLocator === '') {
                  webLocator.baseLocator = false;
                }
                if (webLocator.useJquery === '') {
                  webLocator.useJquery = false;
                }
                if (webLocator.shadowDom === '') {
                  webLocator.shadowDom = false;
                }
                if (webLocator.shadowRoot === '') {
                  webLocator.shadowRoot = false;
                }
              this.selectLocatorToField(webLocator);
                this.close();
                this.createForm.reset();
              } else {
                this.toastr.error(data.message);
              }
            });
          }

        } else {
          this.toastr.error(data.message);
        }
      });
    } else {
      this.userService.addWebLocator(webLocator).subscribe(data => {
        if (data.code === 200) {
          this.toastr.success(data.message);
          if (this.isNewPageLabel) {
            this.userService.getAllPageLabels().subscribe(pageLabels => {
              if (data.code === 200) {
                const selectedPageLabel = pageLabels.response.find(pageLabel => pageLabel.name === webLocator.pageLabel.name);
                webLocator.pageLabel = selectedPageLabel || webLocator.pageLabel;
                this.userService.getWebLocatorById(data.response.id).subscribe(data => {
                  if (data.code === 200) {
                    webLocator = {
                      ...webLocator, "project": null, "createdBy": null, "active": false,
                      "createdOn": null, "updatedBy": null, "updatedOn": null, "id": data.response.id,"parentLocator":data.response.parentLocator,
                    };
                    if (webLocator.baseLocator === '') {
                      webLocator.baseLocator = false;
                    }
                    if (webLocator.useJquery === '') {
                      webLocator.useJquery = false;
                    }
                    if (webLocator.shadowDom === '') {
                      webLocator.shadowDom = false;
                    }
                    if (webLocator.shadowRoot === '') {
                      webLocator.shadowRoot = false;
                    }
                  //  this.selectLocatorToField(data.response)
                  this.selectLocatorToField(webLocator);
                    this.close();
                    this.createForm.reset();
                  } else {
                    this.toastr.error(data.message);
                  }
                });

              } else {
                this.pageLabelList = [];
              }
            });
          }else{
            this.userService.getWebLocatorById(data.response.id).subscribe(data => {
              if (data.code === 200) {
                webLocator = {
                  ...webLocator, "project": null, "createdBy": null, "active": false,
                  "createdOn": null, "updatedBy": null, "updatedOn": null, "id": data.response.id,"parentLocator":data.response.parentLocator,
                };
                if (webLocator.baseLocator === '') {
                  webLocator.baseLocator = false;
                }
                if (webLocator.useJquery === '') {
                  webLocator.useJquery = false;
                }
                if (webLocator.shadowDom === '') {
                  webLocator.shadowDom = false;
                }
                if (webLocator.shadowRoot === '') {
                  webLocator.shadowRoot = false;
                }
              //  this.selectLocatorToField(data.response)
              this.selectLocatorToField(webLocator);
                this.close();
                this.createForm.reset();
              } else {
                this.toastr.error(data.message);
              }
            });

          }
        } else {
          this.toastr.error(data.message);
        }
      });
    }

  }

  getLocatorById(id : any){
    this.userService.getWebLocatorById(id).subscribe(data => {
      if (data.code === 200) {
        this.selectLocatorToField(data.response)
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  cancelCreateForm() {
    this.createForm.reset();
  }

  checkComponentActive(locatorCompType) {
    if (this.fieldName !== constants.fieldNameLocator) { return true; }

    if (this.webInstruction && locatorCompType) {
      if (this.webInstruction.webAction.componentTypes.length > 0) {
        return this.webInstruction.webAction.componentTypes.includes(locatorCompType);
      } else if (this.webInstruction.webAction.componentTypes.length <= 0 && this.webInstruction.webAction.locatorMandate) {
        return true;
      }
    }
  }

  checkForBaseLocators(baseLocator: boolean, locatorCompType) {
    return this.checkComponentActive(locatorCompType) && baseLocator;
  }

  selectLocatorToField(webLocator) {
    this.selectedLocator.emit(webLocator);
  }

  createNewLocator() {
    this.isNewPageLabel = false;
    this.newPageLabelName = '';
    const isUnlabelled = this.pageLabelList.some(label => label.name === constants.pageUnlabelled);
    if(this.pageLabelList.length > 0 && isUnlabelled) {
      this.createForm.controls.pageLabel.setValue(this.pageLabelList.filter(label => label.name === constants.pageUnlabelled)[0]);
    }else{
      this.createForm.controls.pageLabel.setValue({
        id: 1,
        active: true,
        createdBy: null,
        createdOn: null,
        updatedBy: null,
        updatedOn: null,
        name: constants.pageUnlabelled,
        webLocatorIds: null
      });
    }
    
    // Set default component type
    if (this.uiMeta && this.uiMeta.componentTypes && this.uiMeta.componentTypes.length > 0) {
      this.createForm.controls.componentType.setValue(this.uiMeta.componentTypes[14]);
    }
  }

  close() {
    this.activeModal.dismiss();
    this.modalClosed.emit();
  }

  // GETTERs
  get pageLabelControl() {
    return this.createForm.controls.pageLabel;
  }
}
